/* ALTON — hero slideshow: crossfade autoplay, dots, parallax hook. */
(function () {
  'use strict';

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init(section) {
    var hero = section.querySelector('.hero');
    if (!hero || hero.dataset.initialized) return;
    hero.dataset.initialized = 'true';

    var slides = hero.querySelectorAll('.hero-slide');
    var dots = hero.querySelectorAll('.hero-dot');
    var idx = 0;
    var interval = parseInt(hero.dataset.interval || '5', 10) * 1000;
    var timer = null;

    function go(i) {
      idx = (i + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle('active', k === idx); });
      dots.forEach(function (d, k) { d.setAttribute('aria-current', k === idx ? 'true' : 'false'); d.classList.toggle('active', k === idx); });
    }
    function play() {
      if (reducedMotion || slides.length < 2 || hero.dataset.autoplay !== 'true') return;
      clearInterval(timer);
      timer = setInterval(function () { go(idx + 1); }, interval);
    }
    dots.forEach(function (d, k) {
      d.addEventListener('click', function (e) { e.preventDefault(); go(k); play(); });
    });
    go(0);
    play();
  }

  function initAll() {
    document.querySelectorAll('[data-section-type="hero"]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
